import { TApplicationState } from '../../types/redux';

export function getComparisonStatus({ newbuilding: { comparisonStatus } }: TApplicationState) {
  return comparisonStatus;
}
